$(window).resize(() => {
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    $(root).css({'--viewportHeight': `${ viewportHeight }px`})
})